const state = {
  reports: {},
  imeiAction: {},
  storePayoutReportDataToRedirectNERPData: {},
  };
  
  export default state;